import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectValidParams, selectDateRange, selectGridData } from '@pages/reporting-pages/deliveries-main/store/selectors';
import { MainParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { setSearchParameters, setDateRange } from '@pages/reporting-pages/deliveries-main/store/slice';
import { DateRange } from '@project-types/DateRange';
import { useResetDeliveriesMainMutation } from '@api/order-reporting/deliveryApi';
import { AppPage } from 'components/app-page/AppPage';
import ParamsToolbar from '@pages/reporting-pages/deliveries-main/params-toolbar/ParamsToolbar';
import Grid from '@pages/reporting-pages/deliveries-main/grid/Grid';
import { tableHeaders, headersAsValues } from '@pages/reporting-pages/deliveries-main/headersObject';



const DeliveriesMain = () => {

	const validParams = useSelector(selectValidParams);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const dateRange = useSelector(selectDateRange);
	const gridData = useSelector(selectGridData);

	const [ search, setSearch ] = useSearchParams();
	const dispatch = useDispatch();
	const updateSearchParameters = (parameters: MainParams) => dispatch(setSearchParameters(parameters));
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));

	const [ runReset ] = useResetDeliveriesMainMutation();


	useEffect(() => {
		if (!dateRange) {
			updateDateRange({ from: dateWithoutTime, to: dateWithoutTime });
		}
	}, []);

	
	useEffect(() => {
		if (validParams) {
			setSearch({ ...validParams }, { replace: true });
		}
	}, [ validParams ]);

	
	useEffect(() => {
		if (search) {
			let paramDateFrom = search.get('dateFrom');
			let paramDateTo = search.get('dateTo');

			if (!paramDateFrom || !paramDateTo) return;

			let newSearchParams: MainParams = {
				dateFrom: paramDateFrom,
				dateTo: paramDateTo,
			}
			updateSearchParameters(newSearchParams);
		}
	}, [ search ]);


	const resetAllApi = useCallback(() => {
		runReset();
	},[]);


	return (
		<AppPage
			className='reporting-page deliveries-main'
			pageLabel='Report dodávek - hlavní'
			resetPageApi={resetAllApi}
			csvData={{
				headers: tableHeaders,
				data: gridData ? [ headersAsValues, ...gridData ] : [ headersAsValues ],
				filename: 'reporting-dodavky-hlavni'
			}}
		>
			<ParamsToolbar />
			<Grid />
		</AppPage>
	)
};

export default DeliveriesMain;